document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-mm-variant]');
  if (!select) return;
  const form = document.getElementById(select.dataset.formId);
  const selected = select.options[select.selectedIndex];
  if (!selected) return;
  const button = form && form.querySelector('[data-mm-add]');
  const stockMessage = form && form.querySelector('[data-mm-stock]');
  const price = document.querySelector('[data-mm-price="' + select.dataset.formId + '"]');
  if (price) price.textContent = selected.dataset.price;
  if (button) {
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
  }
  if (stockMessage) stockMessage.hidden = selected.dataset.available === 'true';
  const mainImage = document.querySelector('[data-mm-main-image]');
  if (mainImage && selected.dataset.mmImageUrl) {
    mainImage.src = selected.dataset.mmImageUrl;
    mainImage.alt = selected.dataset.mmImageAlt || mainImage.alt;
    document.querySelectorAll('[data-mm-photo]').forEach(function (photo) {
      photo.setAttribute('aria-pressed', String(photo.dataset.mmImageUrl === selected.dataset.mmImageUrl));
    });
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url.toString());
});
document.addEventListener('click', function (event) {
  if (!event.target.closest('.mm-mobile-nav a')) return;
  const menu = event.target.closest('.mm-mobile-nav');
  if (menu) menu.open = false;
});

document.addEventListener('click', function (event) {
  const photo = event.target.closest('[data-mm-photo]');
  if (!photo) return;
  const select = document.querySelector('[data-mm-variant]');
  const color = photo.dataset.mmColor;
  if (select && color) {
    const oldSize = select.options[select.selectedIndex]?.dataset.mmSize;
    const matches = Array.from(select.options).filter(option => option.dataset.mmColor === color);
    const selected = matches.find(option => option.dataset.mmSize === oldSize) || matches[0];
    if (selected) {
      select.value = selected.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }
  const main = document.querySelector('[data-mm-main-image]');
  if (main && photo.dataset.mmImageUrl) {
    main.src = photo.dataset.mmImageUrl;
    main.alt = photo.dataset.mmImageAlt || main.alt;
    document.querySelectorAll('[data-mm-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === photo)));
  }
});
